import { render, staticRenderFns } from "./UserNavigation.vue?vue&type=template&id=9b0d03be&"
import script from "./UserNavigation.vue?vue&type=script&lang=js&"
export * from "./UserNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports